<template>
  <div>
    <Head />
    <Navigation />
    <Wallpaper :src="src"/>
    <List :title="title" :items="items"/>
    <foot />
  </div>
</template>

<script>
import Head from '@/components/index/components/head'
import Wallpaper from '../components/wallpaper'
import List from '../components/list'
import Foot from '@/components/index/components/foot'
import Navigation from '@/components/index/components/nav'
export default {
  name: 'sss',
  components: {
    Head,
    Foot,
    Navigation,
    Wallpaper,
    List
  },
  data () {
    return {
      src: 'http://qkbx01f8g.hb-bkt.clouddn.com/wallpage3.jpg',
      title: '企业简介',
      items : [
        {listName:'企业简介',url:'/intros/mob_1'},
        {listName:'经营理念',url:'/intros/mob_2'},
        {listName:'企业信念',url:'/intros/mob_3'},
        {listName:'业务概念',url:'/intros/mob_4'},
        {listName:'服务宗旨',url:'/intros/mob_5'},
        {listName:'业务范围',url:'/intros/mob_6'},
        {listName:'执照证书',url:'/intros/mob_7'}
        ]
    }
  }
}
</script>

<style scoped>

</style>
